import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()
export class ProvaService {

  constructor(private db: AngularFireDatabase) {
  }

  get() {
    return this.db.list('provas').valueChanges();
  }
  getSnapshot() {
    return this.db.database.ref('provas').once('value');
  }

  updateDisciplina(idprova, prova) {
    const json = {};
    json[idprova] = {
      nomeProva: prova.nomeProva
    };

    return this.db.database.ref(`disciplinas/${prova.disciplinaId}/provas`).update(json);
  }

  insert(prova) {
    return this.db.database.ref(`provas`).push(prova).then(res => {
      return this.updateDisciplina(res.key, prova);
    });
  }

  getById(id) {
    return this.db.database.ref(`provas/${id}`).once('value');
  }

}
